import React from 'react';

const FONT = 'Segoe UI, Calibri, Arial, sans-serif';
const VIEW = { width: 520, height: 200 };
const PLOT = { left: 12, right: 508, top: 28, bottom: 158 };
const FULL = '#FF8000';
const PART = '#FFBF80';

const label = (ms) => (ms >= 1000 ? `${Math.round(ms / 100) / 10} s` : `${Math.round(ms)} ms`);

/**
 * One value per month as bars, oldest on the left. A month that covers only part of the calendar month
 * is drawn lighter and its day range is printed under the month name.
 */
export default function PerformanceChart({ title, points }) {
  const rows = (points || []).filter((point) => point.value != null);
  if (!rows.length) return null;

  const slot = (PLOT.right - PLOT.left) / points.length;
  const barW = Math.min(46, slot * 0.62);
  const max = Math.max(...rows.map((point) => point.value));
  const scale = (PLOT.bottom - PLOT.top) / (max || 1);

  return (
    <figure className="perf-chart">
      <figcaption>{title}</figcaption>
      <svg
        viewBox={`0 0 ${VIEW.width} ${VIEW.height}`}
        role="img"
        aria-label={`${title}: ${points.filter((p) => p.value != null).map((p) => `${p.name} ${label(p.value)}`).join(', ')}`}
      >
        <line x1={PLOT.left} x2={PLOT.right} y1={PLOT.bottom} y2={PLOT.bottom} stroke="#E6E6E6" />
        {points.map((point, index) => {
          const x = PLOT.left + index * slot + (slot - barW) / 2;
          const mid = x + barW / 2;
          const h = point.value != null ? point.value * scale : 0;
          return (
            <g key={point.name}>
              {point.value != null ? (
                <>
                  <rect x={x.toFixed(1)} y={(PLOT.bottom - h).toFixed(1)} width={barW.toFixed(1)} height={h.toFixed(1)} fill={point.coverage ? PART : FULL} />
                  <text x={mid.toFixed(1)} y={(PLOT.bottom - h - 6).toFixed(1)} textAnchor="middle" fontFamily={FONT} fontSize="11" fontWeight="700" fill="#1A1A1A">
                    {label(point.value)}
                  </text>
                </>
              ) : null}
              <text x={mid.toFixed(1)} y={PLOT.bottom + 15} textAnchor="middle" fontFamily={FONT} fontSize="11" fill="#5E5E5E">
                {point.name.slice(0, 3)}
              </text>
              {point.coverage ? (
                <text x={mid.toFixed(1)} y={PLOT.bottom + 28} textAnchor="middle" fontFamily={FONT} fontSize="9.5" fill="#5E5E5E">
                  {point.coverage}
                </text>
              ) : null}
            </g>
          );
        })}
      </svg>
    </figure>
  );
}
